// Carry Roll Total & split aggregation — PSD §4.2.5. Enforces total === carry + roll.
/** Aggregate carry + roll into total, computed exactly once in SI. */
export function aggregate(input) {
    const totalM = input.carryM + input.rollM;
    const rollPercent = totalM > 0 ? input.rollM / totalM : 0;
    const carryPercent = 1 - rollPercent;
    return {
        totalM,
        rollPercent,
        carryPercent,
        playingM: totalM,
    };
}
//# sourceMappingURL=aggregate.js.map